import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { Observable } from 'rxjs/Observable';


export interface Opcion {
  codigo: string;
  descripcion: string;
};

export interface OpcionCheckeable {
  id: string;
  descripcion: string;
  seleccionado: boolean;
};

const selectKeys = [
  'sponsor',
  'productorPrincipal',
];


const tipoBien: Opcion[] = [
{ codigo: '1', descripcion: 'ItemGenerico'},
{ codigo: '2', descripcion: 'ItemVehiculo'},
{ codigo: '3', descripcion: 'ItemCombinadoFamiliar'},
{ codigo: '4', descripcion: 'ItemCaucion'},
{ codigo: '5', descripcion: 'ItemTransporte'},
{ codigo: '6', descripcion: 'ItemVida'},
{ codigo: '7', descripcion: 'ItemRiesgoTrabajo'},
{ codigo: '8', descripcion: 'ItemRetiro'},
{ codigo: '10', descripcion: 'ItemAsistencia'},
{ codigo: '11', descripcion: 'ItemCasco'},
{ codigo: '12', descripcion: 'ItemAsistenciaViaje'},
{ codigo: '13', descripcion: 'ItemConstruccion'},
{ codigo: '14', descripcion: 'ItemVidaGrupo'},
{ codigo: '16', descripcion: 'ItemAgricola'},
{ codigo: '17', descripcion: 'ItemIntegralConsorcio'},
{ codigo: '18', descripcion: 'ItemIntegralComercio'},
{ codigo: '21', descripcion: 'ItemIntegralHogar'},
{ codigo: '22', descripcion: 'ItemVidaSaldoDeudor'},
{ codigo: '24', descripcion: 'ItemUmbrella'},
{ codigo: '25', descripcion: 'ItemMaquinaria'},
{ codigo: '26', descripcion: 'ItemMoto'},
{ codigo: '27', descripcion: 'ItemFianza'}];

@Injectable()
export class SelectsService {
  private url = 'api/settings';

  constructor(private sxHttp: SxHttpService) { }

  /**
   * Dado un tipo de select, retorna el listado de opciones que hidratan el
   * select correspondiente a ese tipo de select
   */
  getSelectFor(tipoSelect: string, filtro: any = null): Observable<Opcion[]> {
    const url = this.url;

    return this.sxHttp.get(url, { tipoSelect, filtro })
      .map(res => res.json().data as Opcion[]);
  }

  /**
   * Provee las keys que identifican las settings
   * que son de tipo select
   */
  getKeys() {
    return selectKeys;
  }

  getListadoTipoBien(): Observable<Opcion[]> {
    return Observable.of(tipoBien);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/selects.service.ts